const breakpointXXL = 1920;

export { breakpointXXL };
